import { InjectionToken } from '@angular/core';

export const MAX_EDITORS = new InjectionToken<number>(
  'PAGE451 EDITOR - MAX EDITORS'
);
